import common from './common'
import writeOffData from './write-off-data'
import writeOff from './write-off'
import eleven from './module/eleven'
import eleven2019 from './module/eleven-2019'
import grabRedEnvelopes from './module/grab-red-envelopes'
import luckyWheel from './module/lucky-wheel'
import getStars from './module/get-stars'
import groupBuying from './module/group-buying'
import luckyKoi from './module/lucky-koi'
import loveGoddess from './module/love-goddess'
import dayDayHappy from './module/day-day-happy'
import nationalDay from './module/national-day'
import reservation from './module/reservation'
import luckyShake from './module/lucky-shake'
import operationEasterEgg from './module/operation-easter-egg'
import customGift  from './module/custom-gift'
import bargainAction  from './module/bargain-action'
import colorRun  from './module/color-run'
import lit from './module/lit'
import mothersday from './module/mothersday'
import inTanabata from './module/in-tanabata'


export default {
  common,
  eleven,
  eleven2019,
  getStars,
  grabRedEnvelopes,
  groupBuying,
  luckyWheel,
  writeOff,
  writeOffData,
  luckyKoi,
  reservation,
  luckyShake,
  operationEasterEgg,
  customGift,
  bargainAction,
  colorRun,
  lit,
  mothersday,
  nationalDay,
  loveGoddess,
  dayDayHappy,
  inTanabata
}